
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { ListCards, ListCardsBase } from '@common-types';
import { LinkSvg } from '@assets';
import { getLocalURI, isExternalUrl, RootState } from '@share/utils';

import { connect } from 'react-redux';
import { ILoginState, IMenuState } from '@share/store/slices';
import { DEFAULT_MEDIA_POINT, RENEWAL_AGENCY_EXCLUDE_RENEWAL } from '@share/constants';

import BeforeYouGo from '@assets/images/list-clickable-cards/before-you-go.png';

import './style.scss';


interface IMapStateToProps {
  loginStore: ILoginState;
  menuStore: IMenuState;
}

interface IProps extends IMapStateToProps {}

function ListClickableCardsComponent(props: IProps) {
  const { loginStore, menuStore } = props;
  const { account, loading } = loginStore;
  const { items } = menuStore;

  const exclude = loading || menuStore?.loading || items?.isRemoveResources;

  const stylesBorder = account?.mainBorderColor ? { borderColor: account?.mainBorderColor } : {};
  const styles = account?.mainBorderRadius ? { ...stylesBorder, borderRadius: `${account?.mainBorderRadius}px` } : { ...stylesBorder };

  const renewalAgency = items?.renewalAgency as string;
  const isRenewalMemberExclude = RENEWAL_AGENCY_EXCLUDE_RENEWAL.includes(renewalAgency);
  const isMobile = document.body.offsetWidth <= DEFAULT_MEDIA_POINT;

  let list = (isRenewalMemberExclude ? ListCardsBase : ListCards).filter(c => !c?.excludeMLM || !items?.isMLM);

  const isLength2 = list.length === 2;
  const isLength3 = list.length === 3;
  

  if (isLength2 || isMobile) {
    list = list.map(l => ({
      ...l,
      image: l.title === 'before.you.go' ? BeforeYouGo : l.image
    }))
  }

  return (
    <div className="list-clickable-cards">
      {!exclude && list.map((item, index) =>
        isExternalUrl(item.url) ? (
          <a
            href={item.url}
            key={`${item.title} ${index}`}
            className={`list-clickable-cards__wrapper ${isLength2 ? 'only-basic' : ''} ${isLength3 ? 'no-renewal' : ''}`}
            target="_blank"
            rel="noreferrer"
            style={styles}
          >
            <div className="list-clickable-cards__img-wrapper">
              <img src={item.image} alt={item.title} />
            </div>
            <div className="list-clickable-cards__info-wrapper">
              <p className="list-clickable-cards__title">
                <FormattedMessage id={item.title} />
              </p>
              <p className="list-clickable-cards__description">
                <FormattedMessage id={item.content} />
              </p>
            </div>
            {!account?.mainHideLinkIcon && (<LinkSvg />)}
          </a>
        ) : (
          <Link
            to={`/${account?.name}${getLocalURI(item.url)}`}
            key={`${item.title} ${index}`}
            className={`list-clickable-cards__wrapper ${isLength2 ? 'only-basic' : ''} ${isLength3 ? 'no-renewal' : ''}`}
            style={styles}
          >
            <div className="list-clickable-cards__img-wrapper">
              <img src={item.image} alt={item.title} />
            </div>
            <div className="list-clickable-cards__info-wrapper">
              <p className="list-clickable-cards__title">
                <FormattedMessage id={item.title} />
              </p>
              <p className="list-clickable-cards__description">
                <FormattedMessage id={item.content} />
              </p>
            </div>
          </Link>
        ),
      )}
    </div>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    menuStore: state.navigationMenuStore,
    loginStore: state.loginStore,
  };
};

export const ListClickableCards = connect(mapStateToProps)(ListClickableCardsComponent);

